import { useQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { PortalAssets } from "@/components/portal/portal-assets";
import { portalAssetHistoryQuery, requirePortalFeature } from "@/lib/portal-data";

export const Route = createFileRoute("/portal/assets/")({
  beforeLoad: ({ context }) => requirePortalFeature(context.queryClient, "assets"),
  loader: ({ context }) => context.queryClient.ensureQueryData(portalAssetHistoryQuery),
  component: PortalAssetsPage,
});

function PortalAssetsPage() {
  const { data } = useQuery(portalAssetHistoryQuery);
  return (
    <div className="space-y-6">
      <div className="space-y-1">
        <h1 className="font-heading font-semibold text-2xl tracking-tight">My assets</h1>
        <p className="text-muted-foreground text-sm">
          Review current and previous company property, acknowledge receipt, and follow asset
          issues.
        </p>
      </div>
      <PortalAssets assets={data ?? []} />
    </div>
  );
}
